import React from 'react';
import Alert from 'antd/lib/alert';
import 'antd/lib/alert/style/index.css';
import Icon from 'antd/lib/icon';
var selfStyles = require('./styles.scss');
var AlertSelectRoundPrompt = function () { return (React.createElement(Alert, { className: selfStyles.alert, message: React.createElement("span", null,
        React.createElement(Icon, { type: 'arrow-up', className: selfStyles.icon }),
        " Select a round to see the scores") })); };
export default AlertSelectRoundPrompt;



//////////////////
// WEBPACK FOOTER
// ./src/imports/components/Scoreboard/components/AlertSelectRoundPrompt.tsx
// module id = 1037
// module chunks = 0